export const accordionTheme = {
  // Aura defaults to a bottom border on every panel; these card-style rows need none.
  panel: {
    borderWidth: '0',
  },
  header: {
    padding: 'var(--rem)',
    borderRadius: 'var(--border-radius)',
    first: {
      topBorderRadius: 'var(--border-radius)',
    },
    last: {
      bottomBorderRadius: 'var(--border-radius)',
    },
  },
  extend: {
    agility: {
      shadow: 'var(--overlay-box-shadow)',
      border: {
        radius: 'var(--border-radius)',
      },
      warning: {
        background: 'var(--p-warning-0)',
      },
      danger: {
        background: 'var(--p-danger-0)',
      },
      surface: {
        background: 'var(--p-surface-200)',
      },
    },
    colorScheme: {
      dark: {
        agility: {
          warning: {
            background: 'var(--p-warning-900)',
          },
          danger: {
            background: 'var(--p-danger-900)',
          },
          surface: {
            background: 'var(--p-surface-800)',
          },
        },
      },
    },
  },
  css: ({ dt }: any) => `
      .p-accordionpanel {
        box-shadow: ${dt('accordion.agility.shadow')};
        border-radius: ${dt('accordion.agility.border.radius')};
      }
      .p-accordionpanel.surface .p-accordionheader,
      .p-accordionpanel.surface:not(.p-accordionpanel-active):not(.p-disabled) > .p-accordionheader:hover,
      .p-accordionpanel.surface:not(.p-disabled).p-accordionpanel-active > .p-accordionheader {
        background: ${dt('accordion.agility.surface.background')};
      }
      .p-accordionpanel.danger .p-accordionheader,
      .p-accordionpanel.danger:not(.p-accordionpanel-active):not(.p-disabled) > .p-accordionheader:hover,
      .p-accordionpanel.danger:not(.p-disabled).p-accordionpanel-active > .p-accordionheader {
        background: ${dt('accordion.agility.danger.background')};
      }
      .p-accordionpanel.warning .p-accordionheader,
      .p-accordionpanel.warning:not(.p-accordionpanel-active):not(.p-disabled) > .p-accordionheader:hover,
      .p-accordionpanel.warning:not(.p-disabled).p-accordionpanel-active > .p-accordionheader {
        background: ${dt('accordion.agility.warning.background')};
      }
    `,
};
